import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Kit from './kit/kit.js';
import ProductQuery from './product/product_query';

import AllCollections from './collections/all_collections.js';
import SingleCollection from './collections/single_collection.js';

var App = function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, App);

		return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	}

	_createClass(App, [{
		key: 'render',
		value: function render() {
			return React.createElement(
				Router,
				null,
				React.createElement(Route, {
					path: '/products/:handle',
					exact: true,
					render: function render(props) {
						return React.createElement(ProductQuery, props);
					}
				}),
				React.createElement(Route, {
					path: '/collections',
					exact: true,
					render: function render(props) {
						return React.createElement(AllCollections, props);
					}
				}),
				React.createElement(Route, {
					path: '/collections/:handle',
					exact: true,
					render: function render(props) {
						return React.createElement(SingleCollection, props);
					}
				})
			);
		}
	}]);

	return App;
}(Component);

export default App;